import React from "react";
import {
  INSPECTOR_CHROME_HOVER_SURFACE,
  INSPECTOR_CHROME_NO_FOCUS_RING,
} from "../../utils/inspectorChromeButtonClasses";
import Tooltip from "../ui/Tooltip";

const VisibilityIconRow = ({ actions = [], trailingContent = null, className = "" }) => {
  const normalizedActions = (actions || []).filter(Boolean);

  return (
    <div className={(className || "").trim() || undefined}>
      <div className="inline-flex w-fit max-w-full items-center rounded-md border border-gray-600 p-0.5">
        <div className="flex flex-nowrap items-center gap-1">
          {normalizedActions.map(({ key, title, on, onClick, disabled, Icon }) => (
            <Tooltip key={key} content={title}>
              <button
                type="button"
                disabled={disabled}
                aria-label={title}
                aria-pressed={on}
                className={`inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-sm border-0 bg-transparent p-0 transition-colors ${INSPECTOR_CHROME_NO_FOCUS_RING} ${INSPECTOR_CHROME_HOVER_SURFACE} ${
                  disabled
                    ? "cursor-not-allowed panel-text-helper"
                    : on
                      ? "cursor-pointer text-white"
                      : "cursor-pointer text-gray-200 hover:text-gray-100"
                }`}
                style={{
                  backgroundColor: "transparent",
                  /* Matches InspectorVisibilityEyeButton (section eye when visuals are off). */
                  opacity: disabled ? 0.35 : on ? 1 : 0.55,
                }}
                onClick={onClick}
              >
                <Icon className="h-4 w-4" />
              </button>
            </Tooltip>
          ))}
          {trailingContent}
        </div>
      </div>
    </div>
  );
};

export default React.memo(VisibilityIconRow);
